import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class AxHeader extends PureComponent {
  static propTypes = {
    headerText: PropTypes.string,
    logo: PropTypes.string,
    countryName: PropTypes.string,
    preview: PropTypes.bool,
    optionalDescription: PropTypes.string,
  }

  static defaultProps = {
    countryName: null,
    headerText: null,
    logo: null,
    preview: false,
    optionalDescription: null,
  }

  render() {
    const {
      countryName,
      logo,
      preview,
      headerText,
      optionalDescription,
    } = this.props;

    let axSubHeader = null;

    const isPicker = window.location.pathname.indexOf('/picker') !== -1;

    if (isPicker) {
      axSubHeader = <p>Choose your country</p>;
    } else if (countryName) {
      axSubHeader = <p>{countryName}</p>;
    }

    return (
      <div className={`openings-directory-layout__header ${optionalDescription && 'openings-directory-layout__header-has-optional-description'}`}>
        <div className="ax-header-text-container">
          {axSubHeader}
          { !preview && (
            <h1 className="openings-directory-layout__header-text">{ headerText || 'Job Openings'}</h1>
          )}
          { optionalDescription &&
            <h5 className="openings-directory-layout__header-optional-description">{optionalDescription}</h5>
          }
        </div>
        <div className="ax-avatar-container">
          <div className="ax-avatar-ring" />
          <div className="ax-avatar-ring inner" />
          <div className="ax-avatar">
            <img src={logo} alt="company logo" />
          </div>
        </div>
      </div>
    );
  }
}
